import React, { useState, useEffect } from "react";
import { Grid, Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogTitle, DialogContent, DialogActions, Switch, Divider } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import FormField from "layouts/pages/users/new-user/components/FormField";
import { Form, Formik } from "formik";
import { get, postNoResponse } from "utils/WebService";
import MDSnackbar from "components/MDSnackbar";

export default function SubCarteirasList({ pessoaId }) {
    const [subCarteiras, setSubCarteiras] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedSubCarteira, setSelectedSubCarteira] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", isSuccess: true });

    useEffect(() => {
        if (pessoaId) {
            fetchSubCarteiras();
        }
    }, [pessoaId]);

    const fetchSubCarteiras = () => {
        setLoading(true);
        get(`/pessoa/by-id/${pessoaId}`)
            .then((data) => {
                setSubCarteiras(data.subCarteiras || []);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const handleOpenDialog = (subCarteira = null) => {
        setSelectedSubCarteira(subCarteira);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedSubCarteira(null);
    };

    const handleSubmit = (values, { setSubmitting }) => {
        const payload = {
            id: values.id,
            idPessoa: pessoaId,
            nome: values.nome,
            descricao: values.descricao,
            ativo: values.ativo,
        };

        postNoResponse("/pessoa/subcarteira/save", payload)
            .then(() => {
                setSnackbar({ open: true, message: "Sub-carteira salva com sucesso!", isSuccess: true });
                handleCloseDialog();
                fetchSubCarteiras();
            })
            .catch((err) => {
                setSnackbar({ open: true, message: "Erro ao salvar sub-carteira.", isSuccess: false });
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    return (
        <MDBox>
            <Divider sx={{ my: 0 }} />
            <MDBox p={3}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <MDTypography variant="h6" fontWeight="medium">Sub-Carteiras</MDTypography>
                    <MDButton variant="gradient" color="info" onClick={() => handleOpenDialog()} startIcon={<Icon>add</Icon>} size="small">
                        Nova Sub-Carteira
                    </MDButton>
                </MDBox>

                <TableContainer sx={{ boxShadow: "none" }}>
                <Table>
                    <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                            <TableCell><MDTypography variant="button" fontWeight="medium" color="text">Nome</MDTypography></TableCell>
                            <TableCell><MDTypography variant="button" fontWeight="medium" color="text">Descrição</MDTypography></TableCell>
                            <TableCell><MDTypography variant="button" fontWeight="medium" color="text">Status</MDTypography></TableCell>
                            <TableCell align="center"><MDTypography variant="button" fontWeight="medium" color="text">Ações</MDTypography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <TableCell colSpan={4} align="center"><MDTypography variant="button" fontWeight="regular" color="text">Carregando...</MDTypography></TableCell>
                            </TableRow>
                        ) : subCarteiras.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={4} align="center"><MDTypography variant="button" fontWeight="regular" color="text">Nenhuma sub-carteira encontrada.</MDTypography></TableCell>
                            </TableRow>
                        ) : (
                            subCarteiras.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell><MDTypography variant="button" fontWeight="regular" color="text">{row.nome}</MDTypography></TableCell>
                                    <TableCell><MDTypography variant="button" fontWeight="regular" color="text">{row.descricao}</MDTypography></TableCell>
                                    <TableCell><MDTypography variant="button" fontWeight="regular" color="text">{row.ativo ? "Ativo" : "Inativo"}</MDTypography></TableCell>
                                    <TableCell align="center">
                                        <IconButton color="info" onClick={() => handleOpenDialog(row)}>
                                            <Icon fontSize="small">edit</Icon>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                <DialogTitle>{selectedSubCarteira ? "Editar Sub-Carteira" : "Nova Sub-Carteira"}</DialogTitle>
                <Formik
                    initialValues={{
                        id: selectedSubCarteira?.id || null,
                        nome: selectedSubCarteira?.nome || "",
                        descricao: selectedSubCarteira?.descricao || "",
                        ativo: selectedSubCarteira ? selectedSubCarteira.ativo : true,
                    }}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ values, handleChange, isSubmitting, setFieldValue }) => (
                        <Form>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <FormField
                                            label="Nome da Sub-Carteira *"
                                            name="nome"
                                            value={values.nome}
                                            onChange={handleChange}
                                            placeholder="Ex: Em Aberto"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormField
                                            label="Descrição"
                                            name="descricao"
                                            value={values.descricao}
                                            onChange={handleChange}
                                            placeholder="Breve descrição"
                                            multiline
                                            rows={2}
                                        />
                                    </Grid>
                                    <Grid item xs={12} display="flex" alignItems="center">
                                        <MDTypography variant="button" sx={{ mr: 1 }}>Ativo</MDTypography>
                                        <Switch checked={values.ativo} onChange={(e) => setFieldValue('ativo', e.target.checked)} />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <MDButton color="secondary" onClick={handleCloseDialog}>
                                    Cancelar
                                </MDButton>
                                <MDButton color="info" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? "Salvando..." : "Salvar"}
                                </MDButton>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            {snackbar.open && (
                <MDSnackbar
                    color={snackbar.isSuccess ? "success" : "error"}
                    icon={snackbar.isSuccess ? "check" : "warning"}
                    title="Aviso"
                    content={snackbar.message}
                    dateTime=""
                    open={snackbar.open}
                    close={() => setSnackbar({ ...snackbar, open: false })}
                />
            )}
            </MDBox>
        </MDBox>
    );
}
